import axios from "axios";
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  USER_CLOSE_WALLET_REQUESTS
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";
import { amApi } from "../../../api/apiHelper";

export const userCloseWalletRequests = (query) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let dataResp = await amApi.get(
      `${serverApi}/closeWallet`,
      { params: query }
    );
    if (dataResp.status === 200) {
      dispatch({ type: USER_CLOSE_WALLET_REQUESTS, payload: dataResp});
      dispatch({ type: CLEAR_LOADER });
    } else {
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

